<template>
  <div class="box">
<!--    <section id="hero">-->
<!--      <div class="container">-->
<!--        <div class="heading-wrapper">-->
<!--          <h2>火焰云加速器</h2>-->
<!--          <p class="mb-2">不限流量，不限时间</p>-->
<!--          <p class="mb-2 mt-2">真正免费的加速器，完美1080P</p>-->
<!--          <p class="mb-2 mt-2 text-primary">尽享隐私保护，网络自由</p>-->
<!--          <p class="mb-2 mt-2 text-danger">买一月赚一年，新用户首次订购会员，最高可获赠365天会员加成！</p>-->
<!--          <p class="mb-2 mt-2 text-primary">老用户续费，最高获赠100天会员！</p>-->
<!--&lt;!&ndash;          <p class="mb-2 mt-2">&ndash;&gt;-->
<!--&lt;!&ndash;            <small>优化支持中国电信、联通、移动网络。</small>&ndash;&gt;-->
<!--&lt;!&ndash;          </p>&ndash;&gt;-->
<!--          <div class="row mt-3">-->
<!--            <div class="col-12">-->
<!--              <a @click="$router.push({name:'login',params:{status:'reg'},query:{t:'reg'}})" class="w-100 primary-btn">新用户注册</a>-->
<!--            </div>-->
<!--            <div class="col-12">-->
<!--              <a @click="$router.push({name:'login',params:{status:'login'}})" target="_blank" class="pr-0  w-100 btn info-btn2">老用户登录</a>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="col-6 pl-1">&ndash;&gt;-->
<!--&lt;!&ndash;              <a @click="$router.push({name:'product'})" class="pl-0 w-100 btn info-btn2">VPN路由器限量购</a>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="col-12">&ndash;&gt;-->
<!--&lt;!&ndash;              <a @click="$router.push({name:'sagetyNet'})" target="_blank" class="w-100 primary-btn">下载防断网客户端，保证任何情况均可登录 （Windows / MAC）</a>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="col-12 mx-auto text-center mt-4">-->
<!--              <a @click="$router.push({name:'share'})" class="pr-2" style="color: #5b617c">如何长期免费使用</a> |-->

<!--              <a @click="$router.push({name:'customer'})" class="pl-2 pr-2" style="color: #5b617c">客服中心</a> |-->

<!--              <a @click="$router.push({name:'tutorials'})" class="pl-2 pr-2" style="color: #5b617c">使用教程</a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->



    <section class="hero-primary">
      <div class="container">
<!--        <img class="hero-title-logo" src="../assets/hero.png" >-->
        <div class="hero-title-0">
          <p class="hero-title-0-p">引领全球游戏加速技术</p>
        </div>
        <p class="hero-title">云启征程</p>
        <p class="hero-title-s">无限可能</p>
        <p class="hero-subtitle">如流云般畅快，似烈焰般激情。让火焰云为您开启全球网游新纪元，突破界限，畅享无限可能。</p>
      </div>
    </section>


    <section id="blog">
      <div class="container">
        <div class="heading-wrapper">
          <h2>为什么选项火焰云</h2>
          <p>了解关于{{this.common.name}}的服务优势，让您更加确定您的选择没有错。</p>

        </div>
        <div class="row topmargin-lg">
          <div class="col-md-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/mainJPG_01.jpg" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>网络加速能力</h5>
                <p>支持提供5-200M的加速带宽（视您的网络环境而定），不限制加速流量。</p>

              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/mainJPG_02.jpg" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>传输加密/解密</h5>
                <p>提供独家的网络加密协议，防侦测、防破解等级更高。</p>

              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/mainJPG_03.jpg" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>智能分流</h5>
                <p>自动优选最佳路线，提供更稳定的网络体验。</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



    <section id="partform">
      <div class="container">
        <div class="heading-wrapper">
          <h2>全平台支持</h2>

        </div>
        <div class="row topmargin-lg">
          <div class="col-md-2-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/partform_01.png" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>Windows</h5>

              </div>
            </div>
          </div>
          <div class="col-md-2-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/partform_02.png" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>macOS</h5>

              </div>
            </div>
          </div>

          <div class="col-md-2-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/partform_04.png" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>Android</h5>

              </div>
            </div>
          </div>

          <div class="col-md-2-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/partform_05.png" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>iOS</h5>

              </div>
            </div>
          </div>

          <div class="col-md-2-4">
            <div class="blog-post">
              <a href="#"><img src="../assets/partform_03.png" class="img-fluid" alt=""></a>
              <div class="blog-post-info">
                <h5>Linux</h5>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section id="pricing">
      <div class="container">
        <div class="heading-wrapper">
          <h2>稳定、快速、易用</h2>
<!--          <p>采用加密协议，安全隐秘，长期使用无忧； <br>客户端支持 Windows 、macOS 、 Linux 、-->
<!--            IOS 、 Android使用</p>-->
        </div>
        <div class="row topmargin-lg">
          <div class="col-md-3">
            <div class="pricing-box">
              <div class="pb-header">
                <i class="icon ion-md-flame"></i>
                <h6>单设备</h6>
                <p>新用户专享福利！订购一月会员，最高可获赠365天会员，超值体验，不容错过！</p>
              </div>
              <div class="pb-subscription">
                <p>20.00元/月</p>

                <a @click="$router.push({name:'money'})" class="primary-btn">去订购</a>
              </div>
              <div class="pb-features">
                <h6 class="text-center">产品特点</h6>
                <ul class="topmargin-sm">
                  <li><i class="icon ion-md-checkmark-circle"></i>不限速度</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>4K视频无限制</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>不限制流量</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>支持各类操作系统接入</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="pricing-box">
              <div class="pb-header">
                <i class="icon ion-md-flame"></i>
                <h6>双设备</h6>
                <p>新用户专享福利！订购一月会员，最高可获赠365天会员，超值体验，不容错过！</p>
              </div>
              <div class="pb-subscription">
                <p>30.00元/月</p>

                <a @click="$router.push({name:'money'})" class="primary-btn">去订购</a>
              </div>
              <div class="pb-features">
                <h6 class="text-center">产品特点</h6>
                <ul class="topmargin-sm">
                  <li><i class="icon ion-md-checkmark-circle"></i>不限速度</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>4K视频无限制</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>不限制流量</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>支持各类操作系统接入</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="pricing-box">
              <div class="pb-header">
                <i class="icon ion-md-flame"></i>
                <h6>三设备</h6>
                <p>新用户专享福利！订购一月会员，最高可获赠365天会员，超值体验，不容错过！</p>
              </div>
              <div class="pb-subscription">
                <p>40.00元/月</p>

                <a @click="$router.push({name:'money'})" class="primary-btn">去订购</a>
              </div>
              <div class="pb-features">
                <h6 class="text-center">产品特点</h6>
                <ul class="topmargin-sm">
                  <li><i class="icon ion-md-checkmark-circle"></i>不限速度</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>4K视频无限制</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>不限制流量</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>支持各类操作系统接入</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="pricing-box">
              <div class="pb-header">
                <i class="icon ion-md-flame"></i>
                <h6 class="pb-white">多设备</h6>
                <p>新用户专享福利！订购一月会员，最高可获赠365天会员，超值体验，不容错过！</p>
              </div>
              <div class="pb-subscription">
                <p>99.00元/月</p>
                <a @click="$router.push({name:'money'})" class="primary-btn">去订购</a>
              </div>
              <div class="pb-features">
                <h6 class="text-center">产品特点</h6>
                <ul class="topmargin-sm pb-white">
                  <li><i class="icon icon-md-checkmark-circle"></i>5台设备同时连接</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>不限速度</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>流畅观看4K及VR视频</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>不限制流量</li>
                  <li><i class="icon ion-md-checkmark-circle"></i>支持各类操作系统接入</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
<!--    <section class="pt-0 test">-->
<!--      <div class="container">-->
<!--        <div class="heading-wrapper">-->
<!--          <h2></h2>-->

<!--        </div>-->
<!--        <div class="row topmargin-lg">-->
<!--          <div class="col-md-12">-->
<!--            <div class="row">-->
<!--              <div class="col-12 col-md-6">-->
<!--                <a href="#"><img src="../assets/luyouqi/luyouqi.jpg" style="max-height: 400px" class="img-fluid" alt=""></a>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-6">-->
<!--                <h2 class="text-center text-md-left mt-4">{{this.common.name}}WiFi路由器</h2>-->
<!--                <p class="mb-2" style="font-size: 19px">-->
<!--                  使用{{this.common.name}}账号的WiFi 路由器，实现您全部WiFi设备，无障碍访问全球网络 <br>-->
<!--                  支持：移动设备 / 电脑 / 智能电视 / 机顶盒 / 游戏机等 <br>-->
<!--                  支持：5-8台设备同时使用-->
<!--                </p>-->
<!--                <p class="mt-md-5">&nbsp;</p>-->

<!--                <p class="text-danger mt-3 mt-md-5">包含价值199元15M速率4KVR版账号一个月 + 80元VPN路由器硬件</p>-->
<!--                <a @click="$router.push({name:'product'})" target="_blank" class="btn btn-success d-block">原价 289元，特价99元限量包邮抢购</a>-->
<!--                <a href="/product-order/course" target="_blank" class="text-right d-block pr-1"-->
<!--                   style="color: #5b617c"></a>-->
<!--                <div class="text-right d-block">-->
<!--                  <a @click="$router.push({name:'useTutorial'})" target="_blank" class="  pr-1" style="color: #5b617c">使用教程</a>&nbsp;|&nbsp;-->
<!--                  <a @click="$router.push({name:'upgradeTutorial'})" target="_blank" class=" pr-1" style="color: #5b617c">路由器升级刷机教程</a>-->
<!--                </div>-->
<!--                <p></p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->



    <section id="faq">
      <div class="container">
        <div class="heading-wrapper">
          <h2>常见客户问题解答</h2>
          <p>提供客户在使用过程中的常见问题解答，希望能够给您提供帮助.</p>
        </div>
        <div id="accordion" class="topmargin-lg">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <a class="btn btn-link collapsed" block v-b-toggle.accordion-0><i class="icon ion-md-add-circle"></i> <b>是否有使用地区，或访问地区的限制？</b></a>
            </b-card-header>
            <b-collapse id="accordion-0" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text> {{this.common.name}}不限制您的使用地区，您在全球任意地区均可通过我们的服务完成连接。</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <a class="btn btn-link collapsed" block v-b-toggle.accordion-1><i class="icon ion-md-add-circle"></i> <b>我连接加速器后，我原有的网络访问是否会受到影响？</b></a>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text> 当您已经接入{{this.common.name}}网络后，您设备上的所有互联网访问都将通过VPN通道完成，会对您访问本地网络（如音乐、视频）服务造成影响。</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <a class="btn btn-link collapsed" block v-b-toggle.accordion-2><i class="icon ion-md-add-circle"></i> <b>我可以在多个设备中同时使用一个账号么？</b></a>
            </b-card-header>
            <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text> 如果您使用的是直接在网站上订购的个人/企业版本，您可以在多个设备中使用一个账号，但无法同时使用。</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </section>




<!--    <section id="footer">-->
<!--      <div class="container">-->
<!--        <div class="heading-wrapper">-->
<!--          <h3>下载客户端 </h3>-->
<!--          <p>请您根据您的操作系统，选择应用程序。</p>-->
<!--          <a :href="this.common.downHost+'/downloads/Windows/anyconnect-win-4.8.03052-core-vpn-predeploy-k9.msi'" class="primary-btn">Windows</a>-->
<!--          <a :href="this.common.downHost+'/downloads/Windows5.0/cisco-secure-client-win-5.0.00556-core-vpn-predeploy-k9.msi'" class="primary-btn">Windows（NEW-->
<!--            version 5.0）</a>-->
<!--          <a :href="this.common.downHost+'/downloads/MacOS10.15/cisco-secure-client-macos-5.0.01242-core-vpn-webdeploy-k9.dmg'" class="primary-btn">MacOS（10.15-->
<!--            Catalina版本以上)</a>-->
<!--          <a :href="this.common.downHost+'/downloads/MacOS13-15/anyconnect-macos-4.7.04056-core-vpn-webdeploy-k9.dmg'" class="primary-btn">MacOS（10.13以上、10.15以下)</a>-->
<!--          <br> <a href="//itunes.apple.com/cn/app/cisco-anyconnect/id1135064690?mt=8" class="primary-btn">IOS（Iphone/Ipad）</a>-->
<!--          <a :href="this.common.downHost+'/downloads/Android/AnyConnect_v4.9.00548.apk'" class="primary-btn">Android （Phone/PAD）</a>-->
<!--          <a :href="this.common.downHost+'/downloads/Android/AnyConnect_5.0.00247.apk'" class="primary-btn">Android （NEW version 5.0）</a>-->
<!--          <a :href="this.common.downHost+'/downloads/OpenConnect_v1.15.apk'" class="primary-btn">Android OpenConnect</a>-->
<!--          <a :href="this.common.downHost+'/downloads/Windows OpenConnect/openconnect-gui-1.5.3-win32.exe'" class="primary-btn">Windows OpenConnect</a>-->
<!--          <a :href="this.common.downHost+'/downloads/OpenConnect/openconnect-gui-1.5.1-darwin.dmg'" class="primary-btn">MacOS OpenConnect</a>-->
<!--        </div>-->
<!--        <div class="row topmargin-lg d-flex justify-content-center">-->
<!--          <div class="col-md-4" >-->
<!--&lt;!&ndash;            <small><a @click="$router.push({name:'answer'})">关于我们</a></small>&ndash;&gt;-->
<!--            <small><a @click="$router.push({name:'privacy'})">隐私政策</a></small>-->
<!--            <small>© Copyright {{year}} {{ this.common.footerLinkStr }}</small>-->
<!--          </div>-->
<!--&lt;!&ndash;          <div class="col-md-4">&ndash;&gt;-->
<!--&lt;!&ndash;            <small><a href="https://beian.miit.gov.cn" target="_blank">{{this.common.beian}}</a></small>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="col-md-4">&ndash;&gt;-->
<!--&lt;!&ndash;            <small>技术支持 <a :href="this.common.homeLink" target="_blank" :title="this.common.name">{{this.common.name}}</a> - Collect from <a&ndash;&gt;-->
<!--&lt;!&ndash;                :href="this.common.homeLink" :title="this.common.name" target="_blank">{{this.common.name}}</a></small>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <footerComponent :showbeian="false"></footerComponent>


  </div>
</template>

<script>
import footerComponent from "@/components/footer";


export default {
  name: "mainComponent",
  components: { footerComponent},
  data(){
    return{
      year:'',
    }
  },
  mounted() {
    this.year = new Date().getFullYear()
  }
}
</script>

<style scoped lang="scss">
p, small {
  color: #5b617c;
  font-family: 'Roboto', sans-serif;
}

.heading-wrapper {
  max-width: 850px;
  margin: 0 auto;
  text-align: center;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #282c47 !important;
}



.hero-primary {
  padding: 11rem 0;
  /*background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #E74C3C 0%, #2C3E50 100%);*/
  background: url(../assets/backgr.png),  linear-gradient(90deg, #E74C3C 0%, #2C3E50 100%);
  background-size: cover;
  /*position: relative;*/
  z-index: -1;
}

.hero-title-logo {
  float: right;
  width: 330px;
  height: 260px;
  margin: 0;
  font-size: 1.5rem;
  -webkit-text-decoration: none;
  text-decoration: none;
  animation-name: b;
  animation-duration: 2s;
}

.hero-title-0 {
  width: 214.02px;
  height: 42px;
  border-radius: 9999px;
  opacity: 1;
  /* 自动布局 */
  display: flex;
  flex-direction: column;
  padding: 8px 24px;
  gap: 0px 10px;
  flex-wrap: wrap;
  align-content: flex-start;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(0, 0, 0, 0), linear-gradient(90deg, rgba(249, 115, 22, 0.2) 0%, rgba(239, 68, 68, 0.1) 100%);
  box-sizing: border-box;
  border: 1px solid rgba(249, 115, 22, 0.2);
  backdrop-filter: blur(4px);
  position: relative; /* 相对于正常位置进行移动 */
  transform: translateY(-60px); /* 向上移动 120px */
}

.hero-title-0-p {
  left: 0px;
  top: -2px;
  width: 164px;
  height: 24px;
  opacity: 1;

  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;

  font-feature-settings: "kern" on;
  color: #FDBA74;
}


.hero-title {
  font-size: 4rem;
  font-feature-settings: "kern" on;
  color: #FFFFFF;
}
.hero-title-s {
  font-size: 4rem;
  font-feature-settings: "kern" on;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #813636 0%, #EF4444 50%, #DC2626 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  font-family: Roboto;
}
.hero-subtitle {
  font-size: 1.5rem;
  color: #D1D5DB;
}






#hero {
  text-align: center;
  font-size: 16px;
  /*margin-top: 10px;*/
  /*padding: 20px 0 80px 0;*/
}

#hero h1 {
  font-size: 46px;
  margin-bottom: 30px;
}

#hero p {
  margin-bottom: 20px;
}

.heading-wrapper p {
  font-size: 20px;
}

.primary-btn {
  background-color: #E74C3C;
  color: #ffffff;
  display: inline-block;
  font-size: 10px;
  margin: 5px;
  padding: 14px 30px;
  border-radius: 4px;
}

.info-btn2 {
  background-color: #28a745;
  color: white !important;
  margin: 5px;
  padding: 0.55rem 0rem;
}

/*/////////////////////////////////////////
Pricing
////////////////////////////////////////*/

#pricing {
  background-color: #f4f4f6;
  padding: 80px 0 80px;
}

.pricing-box {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: #d7d8e2 0px 2px 4px 0px;
  margin: 15px 0;
  transition: all .2s ease-in-out;
}

.pricing-box:hover {
  transform: scale(1.05);
}

.pb-header {
  padding: 30px 24px;
  text-align: center;
  border-bottom: 2px solid #f4f4f6;
}

.pb-header i {
  font-size: 60px;
}

.pb-subscription {
  padding: 30px 24px;
  text-align: center;
  border-bottom: 2px solid #f4f4f6;
}

.pb-features {
  padding: 30px 24px;
}

.pb-features ul {
  list-style-type: none;
  padding-left: 0px;
}

.pb-features ul li {
  margin-bottom: 10px;
}

.pb-features ul li i {
  color: #2d8eff;
  margin-right: 10px;
}

.test {
  padding: 60px 0 !important;
}

/*/////////////////////////////////////////
Frequently asked questions
////////////////////////////////////////*/

#faq {
  background-color: #ffffff;
  padding: 80px 0;
}

.card-header:first-child, .card {
  border-radius: 0px;
}

.card-header {
  background-color: #ffffff;
  border: 0px;
  padding: 5px 0;
}

.card-header i {
  color: #2d8eff;
  font-size: 26px;
  vertical-align: middle;
  margin-right: 6px;
}

.card {
  border: 0px;
  border-top: 1px solid #e9edf5;
}

.card-body {
  padding: 5px 10px 20px 10px;
}

.btn-link {
  color: #282c47;
}

.btn-link:hover {
  color: #282c47;
  opacity: .95;
  text-decoration: none;
}
/*/////////////////////////////////////////
Platform
////////////////////////////////////////*/

#partform {
  background-color: #f4f4f6;
  padding: 80px 0;
}

.col-md-2-4 {
  flex: 0 0 20%; /* 每个子元素占 20% 的宽度 */
  max-width: 20%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
}


@media (max-width: 768px) {
  .col-md-2-4 {
  flex: 0 0 50%; /* 在较小屏幕上每个子元素占 50% 的宽度 */
  max-width: 50%;
}
}

@media (max-width: 480px) {
  .col-md-2-4 {
  flex: 0 0 50%; /* 在更小屏幕上每个子元素占 100% 的宽度 */
  max-width: 50%;
}
}

/*/////////////////////////////////////////
Blog
////////////////////////////////////////*/

#blog {
  background-color: #f4f4f6;
  padding: 80px 0;
}

.blog-post {
  background-color: #ffffff;
  box-shadow: #d7d8e2 0px 2px 4px 0px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  margin: 15px 0;
  transition: all .2s ease-in-out;
}

.blog-post:hover {
  transform: scale(1.05);
}

.blog-post img {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.blog-post-info {
  padding: 24px
}

/*/////////////////////////////////////////
Footer
////////////////////////////////////////*/

#footer {
  background-color: #282c47;
  text-align: center;
  padding: 80px 0 30px 0;
  small a{
    color:#2d8eff;
  }
}

#footer h3 {
  color: #ffffff!important;
  margin-bottom: 25px;
}

#footer i {
  font-size: 20px;
  color: #5b617c;
  margin: 0 5px;
}

/*/////////////////////////////////////////
Media Queries
////////////////////////////////////////*/

@media (max-width: 575.98px) {
  .btn-link {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .nav-item {
    text-align: left;
  }
}

@media (max-width: 991.98px) {
}

@media (max-width: 1199.98px) {
}
</style>

<style scoped>.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-image {
    /* 可以根据需要调整手机端的样式 */
    width: 100%;
    height: 300%;
  }
}

@media (min-width: 769px) {
  .banner-image {
    /* 可以根据需要调整PC端的样式 */
    width: 100%;
    height: auto;
  }
}

</style>